<template>
  <div class="form-group">
    <br />
    <div class="form-buttons">
      <button class="bttn pull-right" @click="$emit('save')">SAVE</button>
      <button class="bttn pull-right" @click="$emit('cancel')">CANCEL</button>
      <!--      <button class="bttn pull-right" @click="$emit('send')">SEND</button>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "form-buttons"
};
</script>

<style lang="scss" scoped>
/*  .btn:first-child {
            margin-left: 4px;
              margin-top: 10px;
          }
          .small-btn{
            min-width: 20px;
            height: 25px;
            font-family: "SegoePro-Regular", Arial, sans-serif;
            font-size: 8pt;
            margin: 2px;
          }*/

.bttn {
  font-family: "Montserrat", Montserrat, serif;
  width: fit-content;
  /* margin-top: 0.5rem;*/
  margin-left: 1rem;
  background: #efefef;
  color: black;
  border: 0;
  font-size: 12px;
  font-weight: 400;
  /*border-radius: inherit;*/
  padding: 5px;

  /*font-family: inherit;*/
  cursor: pointer;
}
</style>
